"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HotspotDto = void 0;
const swagger_1 = require("@nestjs/swagger");
class HotspotDto {}
exports.HotspotDto = HotspotDto;
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Stable id within one computed hotspot list (not stable across recomputations).'
}), __metadata("design:type", String)], HotspotDto.prototype, "id", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Centroid latitude of the hotspot circle.'
}), __metadata("design:type", Number)], HotspotDto.prototype, "centerLatitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Centroid longitude of the hotspot circle.'
}), __metadata("design:type", Number)], HotspotDto.prototype, "centerLongitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Radius in meters: the distance from the center to the farthest assigned member.'
}), __metadata("design:type", Number)], HotspotDto.prototype, "radiusMeters", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Total number of users (real + simulated) assigned to this hotspot.'
}), __metadata("design:type", Number)], HotspotDto.prototype, "userCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Real users assigned to this hotspot.'
}), __metadata("design:type", Number)], HotspotDto.prototype, "realUserCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Simulated users assigned to this hotspot.'
}), __metadata("design:type", Number)], HotspotDto.prototype, "simulatedUserCount", void 0);
//# sourceMappingURL=Hotspot.dto.js.map